import { render, staticRenderFns } from "./UpdateEmployee.vue?vue&type=template&id=f2bbad20&scoped=true"
import script from "./UpdateEmployee.vue?vue&type=script&lang=js"
export * from "./UpdateEmployee.vue?vue&type=script&lang=js"
import style0 from "./UpdateEmployee.vue?vue&type=style&index=0&id=f2bbad20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bbad20",
  null
  
)

export default component.exports